<template>
    <div class="search-container">
        <!-- 搜索输入框 (如果页面其他地方没有，可以取消注释这行) -->
        <!-- <input v-model="searchText" placeholder="请输入城市或车站名称" class="search-input" /> -->

        <div class="search-list">
            <div v-for="(item, index) in processedData" :key="index" class="search-list-item">
                <!-- 城市名称头部 -->
                <div class="search-header" @click.stop="selectItem(item?.matchedStations[0])">
                    <span class="label city-label">城市</span>
                    <span
                        class="city-name"
                        v-html="highlightText(item.cityName, searchText)"
                    ></span>
                </div>

                <!-- 车站列表区域 -->
                <div class="station-list">
                    <!-- 遍历所有车站，根据是否展开来决定显示哪些 -->
                    <div
                        v-for="(station, sIndex) in getVisibleStations(item, index)"
                        :key="sIndex"
                        class="station-item"
                        @click.stop="selectItem(station)"
                    >
                        <span class="label station-label">
                            {{ transportation == 1 ? '火车站' : '机场' }}
                        </span>
                        <span
                            class="station-name"
                            v-html="highlightText(station.stationName, searchText)"
                        ></span>
                    </div>

                    <!-- 底部展开/收起按钮 -->
                    <div
                        v-if="getExpandConfig(item).hasToggle"
                        class="toggle-action"
                        @click.stop="toggleExpand(index)"
                    >
                        {{ item.isExpanded ? '收起' : '查看更多火车站' }}
                        <span class="toggle-icon">{{ item.isExpanded ? '∧' : '∨' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TrainSearch',
  props: {
    list: {
      type: Object,
      default: () => ({})
    },
    transportation: {
      type: Number,
      default: 1
    },
    searchText: {}
  },
  data () {
    return {
      expandedMap: {} // 记录各城市展开状态（城市名 -> 是否展开），保证点击切换时能触发更新
    };
  },
  computed: {
    processedData () {
      if (!this.list || typeof this.list !== 'object') return [];

      const search = String(this.searchText || '').trim().toLowerCase();

      return Object.entries(this.list).map(([cityName, stations]) => {
        const list = Array.isArray(stations) ? stations : [];

        // 命中搜索词的车站（车站名包含关键词），命中后按 sort 升序排序
        const matchedStations = list
          .filter(station => {
            const stationName = String(station.stationName || '');
            return stationName.toLowerCase().includes(search);
          })
          .sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0));

        // 其余未匹配的车站，默认收起，点击展开后再显示
        const unmatchedStations = list.filter(
          station => !matchedStations.includes(station)
        );

        // 车站是否有命中；搜索词非空且城市名命中
        const hasStationMatch = matchedStations.length > 0;
        const cityMatched = !!search && cityName.toLowerCase().includes(search);

        return {
          cityName,
          stations: list,
          matchedStations,
          unmatchedStations,
          hasStationMatch,
          cityMatched,
          isExpanded: !!this.expandedMap[cityName]
        };
      });
    },
  },
  methods: {
    // 获取当前需要展示的车站数组：
    // 匹配结果始终在最前面（有多少展示多少），展开后在其后追加未匹配数据
    getVisibleStations (item) {
      // 车站有命中：收起只展示命中，展开追加未命中
      if (item.matchedStations.length > 0) {
        return item.isExpanded
          ? [...item.matchedStations, ...item.unmatchedStations]
          : item.matchedStations;
      }

      // 车站无命中但城市名命中：默认全部收起，点击展开后才展示全部车站
      if (item.cityMatched) {
        return item.isExpanded ? item.stations : [];
      }

      // 无匹配结果：直接展示全部车站
      return item.stations;
    },
    // 辅助方法：判断当前城市是否需要显示底部按钮
    getExpandConfig (item) {
      // 车站有命中且存在未命中数据时提供"查看更多/收起"
      const hasStationToggle =
        item.matchedStations.length > 0 && item.unmatchedStations.length > 0;
      // 仅城市名命中（全部车站收起）时也提供展开入口
      const hasCityOnlyToggle =
        item.cityMatched &&
        item.matchedStations.length === 0 &&
        item.stations.length > 0;

      return {
        hasToggle: hasStationToggle || hasCityOnlyToggle
      };
    },

    // 切换展开/收起状态（使用 expandedMap 记录，确保响应式更新）
    toggleExpand (index) {
      const item = this.processedData[index];
      console.log(this.processedData, index)
      this.$set(this.expandedMap, item.cityName, !item.isExpanded);
    },

    // 文本高亮处理
    highlightText (text, keyword) {
      if (!keyword || !text) return text;
      const safeText = String(text).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const safeKeyword = String(keyword).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const reg = new RegExp(`(${safeKeyword})`, 'gi');
      return safeText.replace(reg, '<span class="highlight">$1</span>');
    },

    // 点击选中车站
    selectItem (station) {
      this.$emit('select', station);
    }
  }
};
</script>

<style scoped lang="scss">
.search-container {
    width: 100%;
    background-color: #fff;
}

.search-list-item {
    margin-bottom: 0.3rem;
    padding: 0 0.66rem;
    .search-header {
        display: flex;
        align-items: center;
        padding: 0.4rem 0;
        border-bottom: 0.04rem solid #ececec;
        .label {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.06rem 0.2rem;
            border-radius: 0.1rem;
            font-size: 0.45rem;
            margin-right: 0.4rem;
        }
        .city-label {
            background-color: #e6f2ff;
            color: #0072f5;
        }
        .city-name {
            font-size: 0.55rem;
            color: #333;
        }
    }

    .station-list {
        padding-left: 2.2rem; // 给车站留出左侧缩进

        .station-item {
            display: flex;
            align-items: center;
            padding: 0.3rem 0;
            cursor: pointer;
            border-bottom: 0.04rem solid #ececec;

            .label {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 0.06rem 0.2rem;
                border-radius: 0.1rem;
                font-size: 0.45rem;
                margin-right: 0.4rem;
                border: 0.02rem solid #ffe4e4;
                color: #ff4d4f;
            }
            .station-name {
                font-size: 0.53rem;
                color: #333;
            }
        }

        // 底部查看更多/收起按钮样式
        .toggle-action {
            padding: 0.4rem 0 0.6rem 0;
            font-size: 0.53rem;
            color: #333;
            display: flex;
            align-items: center;
            cursor: pointer;

            .toggle-icon {
                margin-left: 0.1rem;
                font-size: 0.5rem;
            }
        }
    }
}

// 搜索高亮颜色
::v-deep .highlight {
    font-size: 0.53rem;
    color: #0072f5;
    font-weight: bold;
}
</style>